import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import CloseIcon from '../../../src/components/icons/CloseIcon'
import Avatar from './Avatar'
import { useSelector } from 'react-redux'


const AvatarCollection = ({ closeFunction = null, selectFunction = null, avatarsArray = [], activeAvatar = null, preventClose }) => {
    const { appMessages = {} } = useSelector(store => store.appConfigReducers)
    const { profileManagementThemes = {} } = useSelector(store => store.profileManagement)
    const [, setTheme] = useState(null)

    // --Setting Profile List Theme---
    useEffect(() => {
        if (profileManagementThemes && profileManagementThemes.themeProfilePopup) setTheme(profileManagementThemes.themeProfilePopup)
    }, [profileManagementThemes])

    return (
        <AvatarCollectionStyled>
            <div className="avatar-collection-wrapper  pop-up-container">
                <div className='avatar-collection-container'>
                    <div className="avatar-collection-container__header">
                        <div className="avatar-collection-container__header__title">{appMessages.label_profile_select_avatar}</div>
                        {!preventClose &&
                            <div className="avatar-collection-container__header__close">
                                <CloseIcon color={"#ffd200"} onClick={closeFunction} style={{ width: 20, height: 20 }} />
                            </div>
                        }
                    </div>
                    <div className="avatar-list">
                        {avatarsArray.map((avatar) => <div className="avatar-list___single" onClick={() => selectFunction(avatar)}>
                            <Avatar className='avatar-collection-container__avatar' height="115px" image={avatar} showBorder={avatar === activeAvatar} status={avatar === activeAvatar ? 'selected' : null} />
                        </div>
                        )}
                    </div>
                </div>
            </div>
        </AvatarCollectionStyled>
    )
}

const AvatarCollectionStyled = styled.div`

`


export default AvatarCollection